var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('settings-screen',{attrs:{"title":"Backup"}},[_vm._v(" Backup settings will appear here! ")])}
var staticRenderFns = []

export { render, staticRenderFns }